"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StormstrikeAbilityHandler = exports.StormstrikeActorAbilityFactory = exports.StormstrikeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
class StormstrikeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Stormstrike;
        this.__typeName = "Stormstrike";
    }
}
exports.StormstrikeAbilityArgs = StormstrikeAbilityArgs;
let StormstrikeActorAbilityFactory = class StormstrikeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Stormstrike", "OneEnemies", 2);
    }
};
StormstrikeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Stormstrike")
], StormstrikeActorAbilityFactory);
exports.StormstrikeActorAbilityFactory = StormstrikeActorAbilityFactory;
let StormstrikeAbilityHandler = class StormstrikeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            sequence,
            targets: Array((0, Random_1.random)(2, 3)).fill(undefined).map(_ => ({
                targetId: selectedEnemy,
                jitter: (0, Random_1.random)(100, 300),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 30),
                    AbilityDamage_1.AbilityDamage.Focus("Physical", 30),
                ],
            })),
            onHit: (sequence) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "DarkLightning"));
                if (container.hasAttribute(ability.invokerId, "Charm_Tempest_1")) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: selectedEnemy,
                        effect: new core_2.ConvulsionsEffectArgs("Focus", 10),
                        duration: Duration_1.Duration.Ticks(16),
                    });
                }
            },
            onMiss: (sequence) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "head"), "FaintYellowGreenCircleDispersion"));
            }
        });
    }
};
StormstrikeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Stormstrike)
], StormstrikeAbilityHandler);
exports.StormstrikeAbilityHandler = StormstrikeAbilityHandler;
